/* eslint-disable camelcase */
import { observer } from "mobx-react-lite"
import moment from "moment"
import { Divider, Icon, useDisclose, View } from "native-base"
import numeral from 'numeral'
import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import {
  Appearance, Dimensions,
  TouchableOpacity,
  useWindowDimensions,
  ViewStyle,
} from "react-native"
import {
  Button,
  FlatList,
  Image,
  JalaIcon,
  JalaLoading,
  ListNetworkError,
  ListRenderItem, ListRenderItemInfo, Screen, SettingItem,
  Text,
} from "../../../../components"
import { translate } from "../../../../i18n"
import { useStores } from "../../../../models"
import { navigate } from "../../../../navigators"
import { color, nativeBaseTheme } from "../../../../theme"
import config from "../../../../utils/config"
import { SafeAreaView } from "react-native-safe-area-context"
import _ from "lodash"
import { getSnapshot } from "mobx-state-tree"
import { ShrimpPriceFilter } from "../../../../components/shrimp-price-filter/shrimp-price-filter"
import { delay } from "../../../../utils/delay"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flex: 1
}

const CONTENT_CONTAINER: ViewStyle = {
  // flexGrow: 1,
  paddingBottom: 68
}

const IMG_PROFILE = {
  width: 40,
  height: 40,
  borderRadius: 20,
}

const MITRA_CONTAINER: ViewStyle = {
  // flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 4
}

const IMG_MITRA = {
  width: 16,
  height: 16,
  borderRadius: 8,
  marginRight: 8,
}

const LIST_EMPTY = {
  width: 135,
  height: 111
}

const FILTER_BUTTON: ViewStyle = {
  flex: 0.40,
  borderTopLeftRadius: 60,
  borderBottomLeftRadius: 60,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  backgroundColor: color.palette.blue700,
  paddingVertical: 0,
  justifyContent: "center"
}

const ADD_BUTTON: ViewStyle = {
  flex: 0.60,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderTopRightRadius: 60,
  borderBottomRightRadius: 60,
  backgroundColor: color.palette.blueAzure
}

const FloatButton: FC<{
  colorScheme?: "light" | "dark",
  shrimpPriceFilterValue?: {
    size?: number,
    country_id?: string,
    region_id?: string,
    verified?: string,
  },
  onShrimpPriceFilterChange?: (value: {
    size?: number,
    country_id?: string,
    region_id?: string,
    verified?: string,
  }) => void
}> = ({
  colorScheme = "light",
  shrimpPriceFilterValue = {},
  onShrimpPriceFilterChange
}) => {
  const { isOpen, onOpen, onClose } = useDisclose(false)
  const { size, ...restFilterValue } = shrimpPriceFilterValue;

  const sizeData = useMemo(() => ([
    { id: 20, name: '20' },
    { id: 30, name: '30' },
    { id: 40, name: '40' },
    { id: 50, name: '50' },
    { id: 60, name: '60' },
    { id: 70, name: '70' },
    { id: 80, name: '80' },
    { id: 90, name: '90' },
    { id: 100, name: '100' },
    { id: 110, name: '110' },
    { id: 120, name: '120' },
    { id: 130, name: '130' },
    { id: 140, name: '140' },
    { id: 150, name: '150' },
    { id: 160, name: '160' },
    { id: 170, name: '170' },
    { id: 180, name: '180' },
    { id: 190, name: '190' },
    { id: 200, name: '200' },
  ]), [])

  const onSizeChange = useCallback((value) => {
    onShrimpPriceFilterChange({
      ...shrimpPriceFilterValue,
      size: value
    })
  }, [onShrimpPriceFilterChange, shrimpPriceFilterValue])

  const onShrimpPriceFilterValueChange = useCallback((value) => {
    onShrimpPriceFilterChange({
      ...value,
      size: size
    })
  }, [onShrimpPriceFilterChange, size])

  return (
    <>
      <View position="absolute" right={0} bottom={0} left={0}>
        <View
          flex={1}
          backgroundColor={colorScheme === 'light' ? nativeBaseTheme.colors.light["50"] : nativeBaseTheme.colors.dark["50"]}
          flexDirection="row" marginX="12px" marginBottom="12px" borderRadius="60px" shadow="4" zIndex={6}
        >
          <SettingItem
            type="picker"
            colorScheme={colorScheme}
            value={size || 100}
            inputProps={{
              value: `${size || 100}`,
              data: sizeData
            }}
            onValueChange={onSizeChange}
            actionsheetProps={{
              titleTx: "Size",
              actionsheetStyle: { minHeight: Dimensions.get('window').height * 0.8 }
            }}
            style={FILTER_BUTTON}
          >
            <View alignSelf="stretch" flexDirection="row" alignItems="center">
              <Icon as={JalaIcon} name="biomass" size="24px" marginY="2px" marginLeft="18px" marginRight="8px" color={color.palette.white} />
              <View>
                <Text tx="Size" preset="body3" color={color.palette.white} />
                <Text text={`${shrimpPriceFilterValue.size || 100}`} preset="title4" color={color.palette.white} />
              </View>
            </View>
          </SettingItem>
          <Button
            testID="jala:id/filter-button"
            preset="primary"
            colorScheme={colorScheme}
            style={ADD_BUTTON}
            onPress={onOpen}
          >
            <View alignSelf="stretch" flexDirection="row" alignItems="center">
              <Icon as={JalaIcon} name="location" size="24px" marginY="2px" marginLeft="10px" marginRight="8px" color={color.palette.white} />
              <Text tx="shrimpPriceListScreen.searchLocation" preset="title3" color={color.palette.white} />
              {!_.isEmpty(restFilterValue) && <View rounded="full" size="8px" backgroundColor="red.500" alignSelf="center" mt="-8px" />}
            </View>
          </Button>
        </View>
        <SafeAreaView edges={["bottom"]} />
      </View>
      <ShrimpPriceFilter
        colorScheme={colorScheme}
        actionsheetProps={{
          titleTx: 'shrimpPriceListScreen.searchLocation'
        }}
        value={shrimpPriceFilterValue}
        onValueChange={onShrimpPriceFilterValueChange}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  )
}

const Header: FC<{ colorScheme?: "light"|"dark" }> = observer(function Header(props) {
  const { colorScheme } = props;
  const {
    shrimpPriceStore: { filterShrimpPrice, region, country }
  } = useStores()
  const [regionName, setRegionName] = useState<string>(null)

  useEffect(() => {
    const regionName = _.isEmpty(region) ? country.name : region.name
    setRegionName(regionName)
  }, [filterShrimpPrice, region, country.name])

  const onPress = useCallback(() => {
    JalaAnalytic.log('Mobile app: create shrimp price');
    navigate('Home.Stack', 'Home.Price.Create.First')
  }, [])

  return (
    <View flexDirection="row" alignItems="center" justifyContent="space-between" paddingX="16px" paddingY="20px">
      <View>
        <Text preset="title3" tx="shrimpPriceListScreen.listShrimpPrice" marginBottom="4px" colorScheme={colorScheme} />
        <View flexDirection="row" alignItems="center">
          <Text preset="body3" text={regionName || ' '} colorScheme={colorScheme} />
          {regionName && <>
            <View size="2px" rounded="1px" marginX="3px"
                  backgroundColor={nativeBaseTheme.colors.gray[colorScheme === "light" ? "800" : "200"]} />
            <Text preset="title5" text={`${translate("shrimpPrices.size")} ${filterShrimpPrice.size || 100}`}
                  transformText={_.startCase} colorScheme={colorScheme} />
          </>}
        </View>
      </View>
      <Button
        testID="jala:id/create-button"
        colorScheme={colorScheme}
        tx="shrimpPriceListScreen.createPrice"
        preset="link"
        textPreset="title4"
        onPress={onPress}
      />
    </View>
  )
})

const Item: FC<{ colorScheme?: "light" | "dark", info: ListRenderItemInfo<any> }> = observer(function Item(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), info } = props;
  const { shrimpPriceStore, shrimpPriceStore: { filterShrimpPrice } } = useStores();
  const {
    item,
    item: {
      country, region, currency, creator, date, currency_id
    }
  } = info;
  const { avatar, name, buyer, state } = creator || {} as any
  const { partner } = state || {} as any

  const { BASE_URL } = config();

  const source = avatar != null && avatar !== 'users/default.png'
    ? { uri: `${BASE_URL}/img/cache/medium/${avatar}` }
    : require("./shrimp-price.png")

  const sizeUsed = filterShrimpPrice.size || 100; // filterSize
  // const prov = region.regency_name && String(region.id) !== '99' ? region.province_name : country.name;
  const price = item[`size_${sizeUsed}`] ? numeral(item[`size_${sizeUsed}`]).format('0,0.[00]') : "-";
  const symbol = currency && currency.symbol || currency_id;
  const dateFormatted = moment(date).format('DD MMM YYYY')

  const regionLevel1 = (region && region.regency_name && region.province_name) || (country && country.name);
  const regionLevel2 = region && (region.regency_name || region.province_name) || '-';

  const onPress = useCallback(async () => {
    shrimpPriceStore.set('shrimpPriceId', item.id)
    await delay(1);
    navigate('Home.Stack', 'Home.ShrimpPrice.Detail')
  }, [item.id, shrimpPriceStore])

  return (
    <TouchableOpacity onPress={onPress}>
      <View paddingBottom="18px" paddingX="16px">
        <View flexDirection="row" marginBottom="12px">
          <View flex={1} flexDirection="row">
            <View width="40px" marginRight="11px">
              <Image key={`profile-${item.id}`} source={source} style={IMG_PROFILE} />
              {buyer && <View
                position="absolute" top="25px" left="20px"
                size="20px" rounded="20px"
                alignItems="center" justifyContent="center"
                shadow={1}
                backgroundColor="yellow.400"
              >
                <Icon as={JalaIcon} name="verified_user" size="15px" textAlign="center" color={color.palette.white} />
              </View>}
            </View>
            <View flex={1} mr="6px">
              {partner && (
                <View style={MITRA_CONTAINER}>
                  <Image source={require("./mitra-logo.png")} style={IMG_MITRA} />
                  <Text preset="body3" tx="homeScreen.partner" colorScheme={colorScheme} />
                </View>
              )}
              <Text text={regionLevel2} preset="title4" marginBottom="2px" colorScheme={colorScheme} />
              <Text text={regionLevel1} preset="body3" marginBottom="8px" colorScheme={colorScheme} />
              <Text text={name} preset="body3" colorScheme={colorScheme} numberOfLines={1} marginRight="25px" />
            </View>
          </View>
          <View alignItems="flex-end">
            {/* <Text preset="title4" text={`${symbol} ${price}`} colorScheme={colorScheme} height="24px" color={nativeBaseTheme.colors.gray[colorScheme === 'light' ? "900" : "100"]} /> */}
            <Text preset="title4" text={`${symbol} ${price}`} colorScheme={colorScheme} height="24px" color={color.primary} />
            <Text preset="title5" text={`${_.startCase(translate("shrimpPrices.size"))} ${sizeUsed}`} marginBottom="2px" colorScheme={colorScheme} />
            <Text preset="body3" text={dateFormatted} colorScheme={colorScheme} />
          </View>
        </View>
        <Divider backgroundColor={nativeBaseTheme.colors.gray[colorScheme === 'light' ? "200" : "800"]} />
      </View>
    </TouchableOpacity>
  )
})

const listEmpty = require('./list-empty.png');

const ListEmpty: FC<{ colorScheme?: "light"|"dark" }> = observer(function ListEmpty(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  return (
    <View
      flexDirection="row"
      rounded="8px"
      borderWidth="1px"
      borderColor={`gray.${colorScheme === 'light' ? '300' : '700' }`}
      marginX="16px"
      paddingY="14px"
      paddingX="8px"
    >
      <Image source={listEmpty} style={LIST_EMPTY} />
      <View flex={1} marginLeft="28px" >
        <Text tx="shrimpPriceListScreen.listEmptyTitle" preset="title3" marginBottom="12px" colorScheme={colorScheme} />
        <Text tx="shrimpPriceListScreen.listEmptySubtitle" preset="body3" colorScheme={colorScheme} />
      </View>
    </View>
  )
})

export const ShrimpPriceListScreen: FC<{ colorScheme?: "light" }> = observer(function ShrimpPriceListScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props
  const { height } = useWindowDimensions();

  // Pull in one of our MST stores
  const {
    shrimpPriceStore,
    shrimpPriceStore: { shrimpPrices, filterShrimpPrice, loadingShrimpPrice, error, needRefresh }
  } = useStores()

  useEffect(() => {
    shrimpPriceStore.init()
  }, [shrimpPriceStore, filterShrimpPrice])

  useEffect(() => {
    if (needRefresh)
      shrimpPriceStore.getShrimpPrices(true, () => {
        shrimpPriceStore.set('needRefresh', false);
        shrimpPriceStore.set('pushIdQueue', {})
      })
  }, [needRefresh, shrimpPriceStore])

  useEffect(() => {
    JalaAnalytic.log('Mobile app: visit list shrimp prices');
  }, [])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    return <Item info={info} colorScheme={colorScheme} />
  }, [colorScheme])

  const keyExtractor = useCallback((item, index) => `${item && item.id || index}`, [])

  const onShrimpPriceFilterChange = useCallback((value) => {
    shrimpPriceStore.set('filterShrimpPrice', { ...value })
    value.region_id ? shrimpPriceStore.getRegion(value.region_id) : shrimpPriceStore.set('region', {})
  }, [shrimpPriceStore])

  const onRefresh = useCallback(() => {
    shrimpPriceStore.set('needRefresh', true);
    shrimpPriceStore.set('error', null);
  }, [shrimpPriceStore])

  return (
    <Screen
      style={ROOT}
      preset="fixed"
      unsafe
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.palette.white : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
      hideOnBlurred={false}
    >
      <FlatList
        data={getSnapshot(shrimpPrices)}
        renderItem={renderItem}
        contentContainerStyle={CONTENT_CONTAINER}
        keyExtractor={keyExtractor}
        ListEmptyComponent={loadingShrimpPrice && (
          <View flexGrow={1} alignItems="center" justifyContent="center" height={`${height - 220}px`}>
            <JalaLoading />
          </View>
        ) || error && (
          <ListNetworkError colorScheme={colorScheme} height={`${height - 220}px`} onRefresh={onRefresh} />
        ) || <ListEmpty colorScheme={colorScheme} />}
        ListHeaderComponent={<Header colorScheme={colorScheme} />}
        ListFooterComponent={<SafeAreaView edges={['bottom']} />}
        estimatedItemSize={94}
        onRefresh={onRefresh}
        refreshing={needRefresh || false}
        onEndReached={shrimpPriceStore.getShrimpPricesNext}
        onEndReachedThreshold={0.1}
        showsVerticalScrollIndicator={false}
      />
       <FloatButton
        colorScheme={colorScheme}
        shrimpPriceFilterValue={filterShrimpPrice}
        onShrimpPriceFilterChange={onShrimpPriceFilterChange}
       />
    </Screen>
  )
})

